import Integrity from "../pages/Integrity";

// Configuración de React Router para evitar warnings de futuras versiones
export const routerConfig = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
};

// Configuración de rutas
export const routes = {
  login: '/login',
  dashboard: '/dashboard',
  traceability: '/traceability',
  reports: '/reports',
  alerts: '/alerts',
  analytics: '/analytics',
  settings: '/settings',
  help: '/help',
  fixtures: '/fixtures',
  talleres: '/talleres',
  injuries: '/injuries',
  decos: '/decos',
  hotLeagues: '/hot-leagues',
  playoffs: '/playoffs',
  contratos: '/contratos',
  agentes: '/agentes',
  cardSearch: '/card-search',
  cuotas: '/cuotas',
  escenarios: '/escenarios',
  Integrity: '/integrity',
  cobertura: '/cobertura',
  mercado: '/mercado',
  connections: '/connections',
  amistosos: '/amistosos',
  informe: '/informe',
  fichajesRiesgo: '/fichajes-riesgo',
  clausulas: '/clausulas',
};

// Función para obtener la ruta de redirección por defecto según el usuario
export const getDefaultRoute = (user) => {
  if (!user) return routes.login;

  if (user.email === 'user@temis.com') {
    return routes.alerts;
  }

  return routes.dashboard;
};

// Función para verificar si un usuario puede acceder a una ruta
export const canUserAccessRoute = (user, pathname) => {
  if (!user) return false;

  const CUOTAS_EMAILS = ['david@temis.com', 'juan@temis.com', 'inaki@temis.com', 'josu@temis.com'];
  const COBERTURA_BLOCKED_EMAILS = ['pras@temis.com'];

  // Rutas desactivadas (comentadas en el menú): bloqueadas para todos
  const DISABLED_ROUTES = [
    routes.reports,
    routes.fixtures,
    routes.talleres,
    routes.decos,
    routes.escenarios,
    routes.Integrity,
  ];
  if (DISABLED_ROUTES.some(route => pathname.startsWith(route))) {
    return false;
  }

  // Usuario de solo alertas
  if (user.email === 'user@temis.com') {
    const allowedPaths = [routes.alerts, routes.help];
    return allowedPaths.some(path => pathname.startsWith(path));
  }

  // Cuotas: solo emails autorizados, sin importar el rol
  if (pathname.startsWith(routes.cuotas)) {
    return CUOTAS_EMAILS.includes(user.email);
  }

  // Cobertura: bloqueada para admins concretos   ← AÑADE ESTE BLOQUE
  if (pathname.startsWith(routes.cobertura) && COBERTURA_BLOCKED_EMAILS.includes(user.email)) {
    return false;
  }

  // Cláusulas: contratos y cláusulas son información sensible → solo admin (explícito)
  if (pathname.startsWith(routes.clausulas)) {
    return user.role === 'admin';
  }

  // Admin: acceso a todo lo demás
  if (user.role === 'admin') {
    return true;
  }

  // Scout (user): solo los apartados "admin + user"
  if (user.role === 'scout') {
    const scoutRoutes = [
      routes.dashboard,
      routes.help,
      routes.settings,
      routes.traceability,
      routes.contratos,
      routes.agentes,
      routes.injuries,
      routes.cardSearch,
      routes.hotLeagues,
    ];
    return scoutRoutes.some(route => pathname.startsWith(route));
  }

  return false;
};